/* eslint-disable @backstage/no-undeclared-imports */
import { useState } from 'react';
import {
  FieldExtensionComponentProps,
  createScaffolderFieldExtension,
} from '@backstage/plugin-scaffolder-react';
import FormControl from '@material-ui/core/FormControl';
import { TextField, InputLabel } from '@material-ui/core';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { useAsync } from 'react-use';
import axios, { HttpStatusCode } from 'axios';
import {
  configApiRef,
  useApi,
  identityApiRef,
} from '@backstage/core-plugin-api';
import {
  TeamcityProjectTreeView,
  buildHierarchy,
  HierarchicalProject,
} from './TeamcityProjectTreeView';

export const TeamcityProjectSchema = {
  uiOptions: {},
  returnValue: { type: 'string' },
};

export const TeamcityProject = ({
  onChange,
}: FieldExtensionComponentProps<string, {}>) => {
  const configApi = useApi(configApiRef);
  const identityApi = useApi(identityApiRef);
  const [selectedProject, setSelectedProject] = useState<HierarchicalProject | null>(null);
  const [projects, setProjects] = useState<HierarchicalProject[]>([]);
  
  const baseURL = `${configApi.getString(
    'backend.baseUrl',
  )}/api/proxy/teamcity-proxy/app/rest/projects`;
  
  const { loading, error } = useAsync(async () => {
    try {
      const { token } = await identityApi.getCredentials();
      const response = await axios({
        url: baseURL,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      
      if (response && response.status !== HttpStatusCode.Ok) {
        throw new Error('Failed to fetch Teamcity projects templates');
      }
      
      const data = await response.data;
      
      if (!data.project || data.project.length === 0) {
        setProjects([]);
        return;
      }
      
      const hierarchy = buildHierarchy(data.project);
      setProjects(hierarchy);
    } catch (err) {
      throw err;
    }
  }, []);

  const handleProjectSelect = (project: HierarchicalProject) => {
    setSelectedProject(project);
    onChange(project.id);
  };

  return (
    <FormControl fullWidth>
      <InputLabel shrink>Teamcity Project</InputLabel>
      
      <TeamcityProjectTreeView
        projects={projects}
        selectedProject={selectedProject}
        onProjectSelect={handleProjectSelect}
        loading={loading}
        error={error?.message}
      />
      
      {selectedProject && (
        <TextField
          value={`${selectedProject.name} (ID: ${selectedProject.id})`}
          variant="outlined"
          size="small"
          disabled
          style={{ marginTop: '8px' }}
          label="Selected Project"
        />
      )}
    </FormControl>
  );
};

export const TeamcityProjectsExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'TeamcityProject',
    component: TeamcityProject,
  }),
);
